export default "__VITE_ASSET__9a1ab6f2__"